import {
	ChangeDetectionStrategy,
	Component,
	input,
	output,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';

import { SheetModule } from '@valk-nx/components/ui-sheet/src';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-filter-button`,
	templateUrl: './filter-button.html',
	imports: [SvgIconComponent, SheetModule, TranslatePipe],
})
export class FilterButtonComponent {
	label = input.required<string>();
	openable = input<boolean>(false);
	iconLeading = input<string | undefined>(undefined);
	indicator = input<number | undefined>(undefined);
	numberOfResults = input<number | undefined>(undefined);

	filterClick = output();

	handleClick() {
		if (!this.openable()) {
			this.filterClick.emit();
		}
	}
}
